// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM8.32324 6.5V8.5H13.2793L9.9707 10.5088V12.7861H12.2061C13.6112 12.7862 14.4998 13.7459 14.5 14.6426C14.5 15.5393 13.6113 16.4999 12.2061 16.5H11.7939C10.3887 16.4999 9.5 15.5393 9.5 14.6426V13.6426H7.5V14.6426C7.5 16.9016 9.56079 18.4999 11.7939 18.5H12.2061C14.4392 18.4999 16.5 16.9016 16.5 14.6426C16.4999 12.7223 15.0106 11.2801 13.1924 10.8906L16.0879 9.13379V6.5H8.32324Z"}}]};

const NumbersCircle3FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-circle-3-filled',
    ref,
    icon: element,
  },
));

NumbersCircle3FilledIcon.displayName = 'NumbersCircle3FilledIcon';

export default NumbersCircle3FilledIcon;
